<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">DIARY OF A</h1>
<h1 class="title1">WARTIME NAVAL CONSTRUCTOR</h1>
<h1 class="title2">SIR STANLEY GOODALL</h1>
<p class="author">EDITED BY IAN BUXTON</p>
<div class="image_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?5cdde454